<template>
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path
      d="M10 17.5c4.112 0 7.5-3.386 7.5-7.496S14.105 2.5 10 2.5c-4.112 0-7.5 3.393-7.5 7.504 0 4.11 3.388 7.496 7.5 7.496zm-2.508-5.068c.285.285.651.258.958-.049l1.499-1.499 1.586 1.587c.3.3.667.339.946.06.29-.29.268-.651-.044-.963l-1.586-1.586 1.586-1.586c.307-.307.334-.673.05-.958-.285-.284-.657-.24-.952.055L9.949 9.079 8.368 7.5c-.307-.307-.679-.34-.969-.05-.279.28-.23.657.066.952l1.58 1.58-1.498 1.5c-.295.295-.339.667-.055.951z"
      fill="#1D1D20"
      fill-rule="evenodd"
    />
  </svg>
</template>
